import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {TooltipModule} from 'ngx-bootstrap/tooltip';

import {DropdownTreeviewComponent} from './dropdown-treeview.component';
import {TreeviewComponent} from './treeview.component';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    TooltipModule
  ],
  declarations: [
    DropdownTreeviewComponent,
    TreeviewComponent
  ],
  exports: [
    DropdownTreeviewComponent,
    TreeviewComponent
  ]
})
export class DropdownTreeviewModule {
  static forRoot(): ModuleWithProviders<DropdownTreeviewModule> {
    return {
      ngModule: DropdownTreeviewModule
    };
  }
}
